export default __webpack_public_path__ + "static/Allgemein-bdb2f1f2b210ec559d0eea8274740eed.png";